import { render, staticRenderFns } from "./SwitchBox.vue?vue&type=template&id=7b09482c&scoped=true&"
import script from "./SwitchBox.vue?vue&type=script&lang=js&"
export * from "./SwitchBox.vue?vue&type=script&lang=js&"
import style0 from "./SwitchBox.vue?vue&type=style&index=0&id=7b09482c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b09482c",
  null
  
)

export default component.exports